import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../redux/actions/user'

//Material UI
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'


import { Chip, ListItemButton, ListItem, ListItemText, Card, List, Modal, Select, FormControl, InputLabel, MenuItem } from '@mui/material'



export default function ModalCreneau({ open, classes, close, setStepContents, setSelectedCrenaux, selectedAbonne, setSelectedAbonne, family, typeRecherche, setStep, selectedActivite, selectedCentre, timeFormat }) {

  const [crenaux, setCrenaux] = useState([])

  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  useEffect(async () => {

    if(!selectedCentre || !selectedActivite) return

    let url = `api/new-souscription/creneaux/${selectedCentre.CNT_ID}/${selectedActivite.ACT_ID}`

    
    const { json, err } = await allActions.fetchGetAPI(url, dispatch, token)
  
    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (err) {
      return enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
    }
  
    //Si le serveur retourne une erreur elle est affiché
    if (json.err) {
      return enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
    }

    setCrenaux(json)
    
    
  }, [selectedCentre, selectedActivite])


  function CustomChip({ enabled, ...rest }) {
    return <Chip
      color={enabled ? 'primary' : undefined}
      icon={enabled ? <CheckCircleIcon /> : <CancelIcon />}
      variant={enabled ? 'default' : 'outlined'}
      {...rest} 
    />
  }


  function getAgeRange(min, max) {
    if(!min && !max) return 'Tout âge'
    if (!min && max) return `Jusqu'à ${max} ans`
    if (min && !max) return `À partir de ${min} ans`
    if (min && max) return `De ${min} ans à ${max} ans`
  }

  function getColor(cours) {
    if(cours.CO_NB_PLACE_SITE - cours.CO_NB_PLACE_PRISES_SITE === 0) {
      return 'red'
    }
    if(cours.CO_NB_PLACE_WEB - cours.CO_NB_PLACE_PRISES === 0) {
      return 'orange'
    }
    return ''
  }

  return (
    <Modal open={open} onClose={close}>
      <Card className={classes.modal}>
        <h3>Créneau: {selectedActivite?.ACT_LIBELLE}</h3>
        <div>
          <FormControl size="small" fullWidth >
            <InputLabel id="abo-label">Abonné</InputLabel>
            <Select
              labelId="abo-label"
              label="Abonné"
              value={selectedAbonne.id}
              onChange={(event) => setSelectedAbonne(family.find(a => a.id === event.target.value))}
            >
              {family.map((f, i) => <MenuItem key={i} value={f.id} >
                {f.name}
                <Chip label={`${f.age} ans`} style={{ height: 'auto', width: 'fit-content', marginLeft: 8 }}/>
              </MenuItem>
              )}
            </Select>
          </FormControl>
        </div>
            
        <List dense className={classes.listCrenaux}>
          {crenaux.map((c, index) => <ListItem disablePadding key={index} className={getColor(c)} >
            <ListItemButton
              onClick={async() => {
                const age_abo = selectedAbonne.age
                const age_min = c.CO_AGEMIN ?? 0
                const age_max = c.CO_AGEMAX ?? 100
                if(age_max < age_abo) {
                  await alert(`Le créneau choisis est déstiné a un public ${getAgeRange(c.CO_AGEMIN, c.CO_AGEMAX)}, or le licencié ${selectedAbonne.name} a ${selectedAbonne.age} ans.`)
                  return
                }
                if(age_abo < age_min) {
                  const res = await confirm(`Vous avez choisis un créneau déstiné a un public ${getAgeRange(c.CO_AGEMIN, c.CO_AGEMAX)}, pour le licencié ${selectedAbonne.name} âgé de ${selectedAbonne.age} ans. Etes vous certain de continuer ?`)
                  if(!res) return
                }

		if(c.CO_NB_PLACE_SITE - c.CO_NB_PLACE_PRISES_SITE === 0) {
                    enqueueSnackbar('Ce créneau est complet', { variant: `error` })
                    return
                }
                if(c.CO_NB_PLACE_WEB - c.CO_NB_PLACE_PRISES === 0) {
                  enqueueSnackbar('Ce créneau est complet sur le web', { variant: `warning` })
                    return
                }

                setStepContents(previous => {
                  const newStepContents = [...previous]
                  newStepContents[1] = (typeRecherche == 0 ? selectedActivite.ACT_LIBELLE : selectedCentre.CNT_LIBELLE)
                  newStepContents[1] += ` - Le ${c.JOUR_LIBELLE} ${timeFormat(c.CO_HEUREDEBUT, c.CO_HEUREFIN)}`
                  return newStepContents
                })

                setSelectedCrenaux(c)
                close()
                setStep(2)
              }} >

              <ListItemText primary={<>
                <div>Le <b>{c.JOUR_LIBELLE}</b> {timeFormat(c.CO_HEUREDEBUT, c.CO_HEUREFIN, true)}</div>
                <div>{c.CO_NB_PLACE_WEB - c.CO_NB_PLACE_PRISES}/{c.CO_NB_PLACE_WEB} places WEB disponibles</div>
                <div>{c.CO_NB_PLACE_SITE - (c.CO_NB_PLACE_PRISES_SITE + c.CO_NB_PLACE_PRISES)}/{c.CO_NB_PLACE_SITE} places CENTRE disponibles</div>
                {c.NIV_LIBELLE && <><Chip label={`Niveau: ${c.NIV_LIBELLE}`} size="small" /> {' '}</>}
                <Chip label={getAgeRange(c.CO_AGEMIN, c.CO_AGEMAX)} size="small" /> <Chip label={`Type: ${c.TA_LIBELLE}`} size="small" />
              </>}/>
            </ListItemButton>
          </ListItem>)}
          {!crenaux.length &&
                <p style={{ textAlign: 'center' }}>Aucun créneau disponible</p>}
        </List>
      </Card>
    </Modal>
  )
}
